import app from '../../dvaInstance'

/**
 * DO NOT TOUCH THIS FUNCTION
 * Checks whether a user has permissions for a given list of actions for IAMv1 logic
 * @todo Deprecate once IAMv2 is implemented
 */
export function checkAuthorization(
  organisation: string | undefined,
  reqPermissions: Array<string>,
  policyLogicalOperator: 'and' | 'or' | undefined = 'and'
): boolean {
  let valid
  const policyEvalFunction =
    policyLogicalOperator === 'and' ? reqPermissions.every : reqPermissions.some
  // @ts-expect-error : Will update later
  const response = app._store.getState().auth.user.permissions
  // console.log("response org independent ", response.org_independent_access)
  // console.log("response org dependent", response.org_dependent_access)
  // console.log("req permisisons ", reqPermissions)
  if ('all_orgs' in response.org_dependent_access) {
    if (response.org_dependent_access['all_orgs'].includes('_all_')) {
      // console.log("authorized")
      return true
    } else {
      let value = policyEvalFunction.call(reqPermissions, (permission) =>
        response.org_dependent_access['all_orgs'].includes(permission)
      )
      // console.log("inside all_orgs dependent check, authorized:",value);
      valid = value
      if (valid) {
        return value
      }
    }
  }
  if (organisation == '') {
    if ('_all_' in response.org_independent_access) {
      return true
    }

    let value = policyEvalFunction.call(reqPermissions, (permission) =>
      response.org_independent_access.includes(permission)
    )
    // console.log("inside org independent check, authorized:",value)
    valid = value
    return valid
  } else {
    if (organisation in response.org_dependent_access) {
      if ('_all_' in response.org_dependent_access[organisation]) {
        // console.log("all authorized")
        return true
      }

      let value = policyEvalFunction.call(reqPermissions, (permission) =>
        response.org_dependent_access[organisation].includes(permission)
      )
      // console.log("inside org dependent check, authorized:",value);
      return value
    } else {
      return false
    }
  }
}

function _evaluateFinalPermissionStatus(
  requiredPermissionsAuthStatusMapping: any,
  requiredPermissions: Array<string>
) {
  console.log('requiredPermissionsAuthStatusMapping', requiredPermissionsAuthStatusMapping)
  for (const permission of requiredPermissions) {
    if (requiredPermissionsAuthStatusMapping[permission] === false) return false
  }
  return true
}
function _processPermissionsIfExists(
  requiredPermissionsAuthStatusMapping: any,
  requiredPermissions: string[],
  permittedActions: string[] | null
) {
  if (!permittedActions) return []
  const permissionsAuthorized: string[] = []
  requiredPermissions.forEach((p: string) => {
    if (permittedActions.indexOf(p) > -1 && requiredPermissionsAuthStatusMapping[p] === false) {
      requiredPermissionsAuthStatusMapping[p] = true
      permissionsAuthorized.push(p)
    }
  })
  return permissionsAuthorized
}
function _processContentTypePermissions(
  priorityOrder: string[],
  userPermissions: any,
  requiredPermissions: string[],
  contentTypeValueMapping: any,
  requiredPermissionsAuthStatusMapping: any
) {
  for (let priorityContentType of priorityOrder) {
    const currentTypePermissions: any = userPermissions[priorityContentType]
    const value = contentTypeValueMapping[priorityContentType]

    let permittedActions: string[] | null

    if (Array.isArray(currentTypePermissions)) permittedActions = currentTypePermissions
    else if (currentTypePermissions && currentTypePermissions[value])
      permittedActions = currentTypePermissions[value]
    else permittedActions = null

    const permissionsAuthorized = _processPermissionsIfExists(
      requiredPermissionsAuthStatusMapping,
      requiredPermissions,
      permittedActions
    )

    if (permissionsAuthorized.length > 0)
      console.log(
        `PrincipleScope '${priorityContentType}' authorized '${permissionsAuthorized.join(',')}' `
      )
  }
}

/**
 * checkAuthorizationV2 checks if the all the actions under "requiredPermissions"
 * is accessable by the current user against the order specified in "priorityOrder"
 *
 * @param {string[]} priorityOrder - Defines the order in which the permissions are to be checked for authorization.
 * @param {string[]} requiredPermissionse - A list of all the actions that is required for access
 * @param {Object} extraInfo - Additional info which includes "organisation_uuid" ,"flow_uuid"
 *
 * @returns {boolean}
 */
function checkAuthorizationV2(
  priorityOrder: string[],
  requiredPermissions: string[],
  extraInfo: {
    organisation_uuid?: string
    flow_uuid?: string
  }
): boolean {
  console.log('-------AUTH EVALUATION START-------')
  console.log('Required Permissions: ', requiredPermissions)

  // @ts-expect-error : Will update later
  const userPermissions: any = app._store.getState().auth.user.permissions
  const requiredPermissionsAuthStatusMapping: any = {}

  const contentTypeValueMapping: any = {
    organisation: extraInfo.organisation_uuid,
    flows: extraInfo.flow_uuid,
  }

  requiredPermissions.forEach((p) => (requiredPermissionsAuthStatusMapping[p] = false))

  _processContentTypePermissions(
    priorityOrder,
    userPermissions,
    requiredPermissions,
    contentTypeValueMapping,
    requiredPermissionsAuthStatusMapping
  )

  const finalAuthStatus = _evaluateFinalPermissionStatus(
    requiredPermissionsAuthStatusMapping,
    requiredPermissions
  )

  console.log('Required Permissions Authorized: ', finalAuthStatus)
  console.log('-------AUTH EVALUATION END---------')
  return finalAuthStatus
}
